import React from 'react'
import { BackArrowIcon } from 'assests/GmsIcons';

type AttributeValuesMappingHeaderProps = {
    attributeValuesCount: number | null;
    onBack: () => void;
    onDone: () => void;
}
const AttributeValuesMappingHeader = ({ attributeValuesCount, onBack, onDone }: AttributeValuesMappingHeaderProps) => {
    return (
        <div className="tw-flex tw-justify-between tw-items-center tw-px-6">
            <div className="tw-flex tw-items-center tw-gap-8">
                <span
                    onClick={onBack}
                    className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer hover:tw-text-[#0747a6]"
                >
                    <BackArrowIcon />
                    <span className="tw-text-sm tw-font-medium">Back</span>
                </span>

                <span className="tw-text-[#172b4d] tw-text-sm tw-font-semibold">
                    {attributeValuesCount} Attribute values
                </span>
            </div>

            <button
                onClick={onDone}
                className="button-style"
            >
                Done
            </button>
        </div>
    )
}

export default AttributeValuesMappingHeader